/**
 * Allowed hostnames for internal-only features like SendACommand
 */
const ALLOWED_HOSTNAMES = [
  "breeze.anythink.dev",
  "breeze.anythink.cloud",
  "localhost:3000",
];

/**
 * Checks if the current hostname is allowed for internal features
 * @returns {boolean} True if hostname is allowed, false otherwise
 */
export function isInternalHostname(): boolean {
  if (typeof window === "undefined") {
    // Server-side rendering - default to false for safety
    return false;
  }

  const currentHostname = window.location.host;
  return ALLOWED_HOSTNAMES.includes(currentHostname);
}

/**
 * Gets the list of allowed hostnames for internal features
 * @returns {string[]} Array of allowed hostnames
 */
export function getAllowedHostnames(): string[] {
  return [...ALLOWED_HOSTNAMES];
}

/**
 * Extract org ID from a request URL
 */
export const extractOrgIdFromUrl = (url: string | undefined): number | null => {
  if (!url) return null;
  const match = url.match(/\/org\/(\d+)(?:\/|$)/);
  if (match && match[1]) {
    const orgId = parseInt(match[1], 10);
    return isNaN(orgId) ? null : orgId;
  }
  return null;
};
